import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  useGetIsThisYouBySlugQuery,
  useUpdateIsThisYouMutation,
  useCreateIsThisYouMutation
} from 'api/workshopApi';

const WorkshopIsThisYou = () => {
  const { slug } = useParams();

  const {
    data: isThisYouData,
    isLoading: isIsThisYouLoading,
    refetch,
  } = useGetIsThisYouBySlugQuery(slug);

  const [updateIsThisYou, { isLoading: isUpdating }] = useUpdateIsThisYouMutation();
  const [createIsThisYou, { isLoading: isCreating }] = useCreateIsThisYouMutation();

  const [tagline, setTagline] = useState('');
  const [questions, setQuestions] = useState(['']);

  useEffect(() => {
    if (isThisYouData?.data) {
      setTagline(isThisYouData.data.tagline || '');
      const fetchedQuestions = isThisYouData.data.questions;
      setQuestions(Array.isArray(fetchedQuestions) && fetchedQuestions.length > 0 ? fetchedQuestions : ['']);
    } else {
      setTagline('');
      setQuestions(['']);
    }
  }, [isThisYouData]);

  const handleQuestionChange = (index, value) => {
    const updated = [...questions];
    updated[index] = value;
    setQuestions(updated);
  };

  const handleAddQuestion = () => setQuestions([...questions, '']);

  const handleRemoveQuestion = (index) =>
    setQuestions(questions.filter((_, i) => i !== index));

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = { tagline, questions };

    try {
      if (isThisYouData?.data) {
        await updateIsThisYou({ slug, formData }).unwrap();
        alert('Updated successfully');
      } else {
        await createIsThisYou({ slug, formData }).unwrap();
        alert('Created successfully');
      }
      refetch();
    } catch (error) {
      console.error('Operation failed', error);
      alert('Failed to save data');
    }
  };

  return (
    <section className="max-w-4xl w-full mx-auto mt-10 p-4 sm:p-6 border rounded-lg shadow bg-white">
      <h2 className="text-2xl font-semibold mb-4 text-center sm:text-left">Is This You?</h2>

      {isIsThisYouLoading && <p className="mb-4 text-gray-500 text-center">Loading...</p>}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block font-semibold mb-1">Tagline</label>
          <input
            type="text"
            value={tagline}
            onChange={(e) => setTagline(e.target.value)}
            className="border p-2 rounded w-full focus:outline-none focus:ring-2 focus:ring-green-400"
            placeholder="Enter tagline"
          />
        </div>

        <div>
          <label className="block font-semibold mb-2">Questions</label>
          {questions.map((q, i) => (
            <div
              key={i}
              className="flex flex-col sm:flex-row sm:items-center mb-3 gap-2"
            >
              <input
                type="text"
                value={q}
                onChange={(e) => handleQuestionChange(i, e.target.value)}
                className="border p-2 rounded w-full sm:flex-1 focus:outline-none focus:ring-2 focus:ring-green-400"
                placeholder={`Question ${i + 1}`}
              />
              {questions.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveQuestion(i)}
                  className="text-red-600 hover:text-red-800 self-start sm:self-auto"
                  aria-label={`Remove question ${i + 1}`}
                >
                  ✕
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddQuestion}
            className="text-blue-600 hover:text-blue-800 mt-2"
          >
            + Add Question
          </button>
        </div>

        <button
          type="submit"
          disabled={isUpdating || isCreating}
          className={`w-full sm:w-auto bg-green-600 text-white px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {(isUpdating || isCreating)
            ? 'Saving...'
            : isThisYouData?.data
              ? 'Update Section'
              : 'Create Section'}
        </button>
      </form>
    </section>
  );
};

export default WorkshopIsThisYou;

